import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  submitPlanForReview,
  type SubmissionCreateBody,
} from '@/api/submissions'
import { queryKeys } from '@/lib/queryKeys'

/**
 * Hook for submitting a plan for review.
 * On success, invalidates the plan detail query to refetch latest status.
 */
export function useSubmitForReview(planId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data?: SubmissionCreateBody) =>
      submitPlanForReview(planId, data),
    onSuccess: () => {
      // Invalidate plan detail to refetch with updated status
      queryClient.invalidateQueries({
        queryKey: queryKeys.planDetail.byId(planId),
      })
      // Invalidate metadata query to update the status badge
      queryClient.invalidateQueries({
        queryKey: queryKeys.planDetail.metadata(planId),
      })
      // Also invalidate the plan list in case status changed
      queryClient.invalidateQueries({
        queryKey: queryKeys.assortmentPlans.all,
      })
      // Invalidate submissions so the unsubmit button appears immediately
      queryClient.invalidateQueries({
        queryKey: queryKeys.submissions.byPlanId(planId),
      })
    },
  })
}
